<template>
  <div class="not-found" role="alert">
    <h1>{{ copy.title }}</h1>
    <p class="not-found-message">{{ copy.message }}</p>
    <div class="not-found-actions">
      <router-link :to="browsePath" class="not-found-link">Browse cruises</router-link>
      <router-link to="/" class="not-found-link not-found-link--secondary">Back to Home</router-link>
    </div>
  </div>
</template>

<script>
import { BROWSE_PATH, applyNoindex, notFoundCopy } from '@/utils/notFound';

export default {
  name: 'NotFound',
  props: {
    // 'page' (catch-all route) or 'cruise' (unknown or hidden /cruise/<id>)
    variant: { type: String, default: 'page' }
  },
  data() {
    return { removeNoindex: null };
  },
  computed: {
    copy() {
      return notFoundCopy(this.variant);
    },
    browsePath() {
      return BROWSE_PATH;
    }
  },
  mounted() {
    // A 404 page must not be indexed, even when a crawler renders the SPA.
    this.removeNoindex = applyNoindex(document);
  },
  beforeUnmount() {
    if (this.removeNoindex) this.removeNoindex();
  }
};
</script>

<style scoped>
.not-found {
  max-width: 720px;
  margin: 0 auto;
  padding: var(--space-6) var(--space-4);
  text-align: center;
  color: var(--cs-ink);
}

.not-found h1 {
  font-family: var(--font-heading);
  font-size: var(--text-h1);
  font-weight: 700;
  line-height: var(--line-height-tight);
  margin: 0 0 var(--space-3);
}

.not-found-message {
  font-size: var(--text-body);
  color: var(--cs-muted);
  margin: 0 0 var(--space-5);
}

.not-found-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-3);
}

.not-found-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: var(--touch-min);
  padding: var(--space-3) var(--space-5);
  background-color: var(--cs-fill);
  color: white;
  border: 2px solid var(--cs-signal-teal);
  border-radius: var(--radius-md);
  font-weight: 600;
  text-decoration: none;
  transition: background var(--transition-normal);
}

.not-found-link:hover {
  background-color: var(--cs-fill-hover);
  border-color: var(--color-primary-hover);
}

.not-found-link--secondary {
  background-color: transparent;
  color: var(--cs-signal-teal);
}

.not-found-link--secondary:hover {
  background-color: transparent;
  color: var(--color-primary-hover);
}

.not-found-link:focus-visible {
  outline: 2px solid var(--cs-signal-teal);
  outline-offset: 2px;
}
</style>
